import styled from "styled-components";

export const DefinitionText = styled.div`
    color: var(--Basic-900);
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 16px;
    text-wrap: nowrap;
`

export const PositionsWrapper = styled.div`
    margin-bottom: 35px;
`